class ViewSwitch extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  setupListeners () {
    super.setupListeners()

    this.handleLayoutToggle = this.handleLayoutToggle.bind(this)

    this.listeners.add(this, 'click', this.handleLayoutToggle)
  }

  async handleLayoutToggle () {
    const listClass = `clc-ProductGrid`

    const currentLayout = this.dataset.view

    const newLayout = currentLayout === 'list' ? 'grid' : 'list'

    await window.BAO.Cart.updateCartAttributes({
      collection_view: newLayout,
    })

    this.setAttribute(`data-view`, newLayout)

    this.externalEls.grid.element.classList.remove(
      `${listClass}-${currentLayout}`,
    )
    this.externalEls.grid.element.classList.add(`${listClass}-${newLayout}`)

    window.setTimeout(() => {
      this.externalEls.grid.element.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }
}

if (!customElements.get('view-switch')) {
  customElements.define('view-switch', ViewSwitch, { extends: 'button' })
}
